import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import InsHeaderConnect from "components/InsHeaderConnect/InsHeaderConnect";
import Step1 from "./Step1/Step1";
import Step2 from "./Step2/Step2";
import Step3 from "./Step3/Step3";
import { useDispatch } from "react-redux";
import { updateInfos } from "store/actions/createAccountAction";
import { createAccountAPI } from "../../../api/account";
import { useTranslation } from "react-i18next";

const Create = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const accountCreationState = useSelector(
    (state) => state.createAccount.userInfo
  );
  const [step, setstep] = useState(1);
  const [error, seterror] = useState("");

  const createAccount = (data) => {
    const finalData = { ...accountCreationState, ...data };
    dispatch(updateInfos(finalData));

    createAccountAPI(finalData).then(
      (data) => {
        //value a changer pour la bonne data
        let value = data.active;
        history.replace("/connect/create-success", {
          isCreated: value,
        });
      },
      (_error) => {
        console.log("erreur requete api : " + _error);
        seterror(_error);
      }
    );
  };

  const nextStep = (data) => {
    const locationState = {
      goBack: true,
      step: step + 1,
    };
    setstep((state) => state + 1);
    dispatch(updateInfos(data));
    history.push("/connect/create", locationState);
  };

  const goBack = () => {
    setstep((state) => state - 1);
  };

  const CurrentStep = () => {
    switch (step) {
      case 1:
        return <Step1 onValidate={nextStep} userInfo={accountCreationState} />;

      case 2:
        return <Step2 onValidate={nextStep} userInfo={accountCreationState} />;

      case 3:
        return (
          <Step3 onValidate={createAccount} userInfo={accountCreationState} />
        );

      case 0:
      default:
        return <Step1 onValidate={nextStep} userInfo={accountCreationState} />;
    }
  };

  return (
    <>
      <InsHeaderConnect title={t("create_account")} onGoBack={goBack} />
      <div className="step3-error-validate-account">{error}</div>
      <CurrentStep />
    </>
  );
};

export default Create;
